import type { ApiErrorInputsResponse, ApiErrorResponse, ApiNewErrorResponse } from '@/shared/model/types/error';

export type NormalizedApiError = {
  format: 'new' | 'legacy' | 'inputs' | 'unknown';
  httpStatus?: number;
  code?: string | number;
  message: string;
  details?: Record<string, unknown>;
  fields?: Record<string, string[]>;
};

export const normalizeApiError = (error: unknown): NormalizedApiError | null => {
  if (typeof error !== 'object' || error == null) {
    return null;
  }

  if ('status' in error && (error as any).status === 'FETCH_ERROR') {
    return {
      format: 'unknown',
      message: 'Нет соединения с сетью. Проверьте интернет.',
    };
  }

  if (!('data' in error)) {
    return 'message' in error && typeof error.message === 'string' && error.message.trim()
      ? { format: 'unknown', message: error.message }
      : null;
  }

  const data = (error as any).data;
  const status = typeof (error as any).status === 'number' ? (error as any).status : undefined;

  if (typeof data === 'object' && data != null && 'code' in data && 'message' in data) {
    const e = error as ApiNewErrorResponse;
    const payload = e.data;

    const details =
      payload.details && typeof payload.details === 'object' ? (payload.details as Record<string, unknown>) : undefined;

    const fields =
      details && 'fields' in details && typeof (details as any).fields === 'object' && (details as any).fields != null
        ? ((details as any).fields as Record<string, string[]>)
        : undefined;

    return {
      format: 'new',
      httpStatus: status,
      code: payload.code,
      message: payload.message,
      details,
      fields,
    };
  }

  if (
    typeof data === 'object' &&
    data != null &&
    'error' in data &&
    ((data as any).error === 'Не корректные данные' ||
      (data as any).error === 'Некорректные данные' ||
      (data as any).error === 'Invalid data') &&
    'details' in data
  ) {
    const e = error as ApiErrorInputsResponse;
    const fields = e.data.details;

    return {
      format: 'inputs',
      httpStatus: status,
      message: typeof (data as any).error === 'string' ? ((data as any).error as string) : 'Некорректные данные',
      fields,
    };
  }

  if (
    typeof data === 'object' &&
    data != null &&
    'error' in data &&
    (data as any).error === 'API exception' &&
    'details' in data
  ) {
    const e = error as ApiErrorResponse;
    const d = e.data.details;

    return {
      format: 'legacy',
      httpStatus: status,
      code: d.code,
      message: 'Произошла ошибка',
      details: (e.data.details as unknown as Record<string, unknown>) || undefined,
    };
  }

  return {
    format: 'unknown',
    httpStatus: status,
    message:
      typeof data?.message === 'string' && data.message.trim()
        ? data.message
        : 'message' in error && typeof error.message === 'string' && error.message.trim()
          ? error.message
          : 'Произошла неизвестная ошибка',
  };
};
